export const resyncChatForPush = async (store, target = {}) => {
  const chatState = store?.state?.chat;
  const roomNo = target.roomNo;
  if (
    !Number.isSafeInteger(roomNo) ||
    roomNo <= 0 ||
    Number(chatState?.desiredRoomNo) !== roomNo ||
    Number(chatState?.subscribedRoomNo) !== roomNo ||
    Number(chatState?.selectedRoom?.roomNo) !== roomNo
  ) return false;
  const chats = chatState?.chats?.data ?? [];

  if (chats.length > 0) return store.dispatch('chat/fetchLastChat');

  store.commit('chat/flushChatData');
  return store.dispatch('chat/fetchChatList', { roomNo: target.roomNo });
};
